(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["review-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nb-review-composer')) {
    customElements.define('nb-review-composer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', event => {
          if (event.target.closest('[data-review-cancel]')) this.dialog.close();
        });
        if (this.querySelector('[data-review-result]')) this.open();
      }
      open() { if (!this.dialog.open) this.dialog.showModal(); }
      disconnectedCallback() { this.dialog?.close(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
